var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentFavoritesLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Document-Favorites-Line") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Codigo-de-Etica",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CdE_Web",
    transform: "translate(-306.000000, -272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document-Favorites-Line",
    transform: "translate(306.000000, 272.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 50.4,
    height: 50.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.053,6.78298513 L14.553,6.78298513 C13.2664884,6.77979624 12.032814,7.29445797 11.13,8.211 C10.2213242,9.11910684 9.70809183,10.3493551 9.702,11.634 L9.702,38.766 C9.70809183,40.0506449 10.2213242,41.2808932 11.13,42.189 C12.032814,43.105542 13.2664884,43.6202038 14.553,43.6170149 L35.868,43.6170149 C37.1545116,43.6202038 38.388186,43.105542 39.291,42.189 C40.1996758,41.2808932 40.7129082,40.0506449 40.719,38.766 L40.719,22.47 L25.053,6.78298513 Z M25.494,9.975 L37.548,22.05 L25.494,22.05 L25.494,9.975 Z M38.766,38.766 C38.7819936,39.5508802 38.4788782,40.3086686 37.926,40.866 C37.3694646,41.4225193 36.6130282,41.7326582 35.826,41.7270761 L14.532,41.7270761 C13.7449718,41.7326582 12.9885354,41.4225193 12.432,40.866 C11.8791218,40.3086686 11.5760064,39.5508802 11.592,38.766 L11.592,11.634 C11.5760064,10.8491198 11.8791218,10.0913314 12.432,9.534 C12.9885354,8.97748068 13.7449718,8.66734178 14.532,8.67292392 L23.541,8.67292392 L23.541,23.94 L38.766,23.94 L38.766,38.766 Z",
    id: "Shape",
    fill: "#1D1D1B",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFavoritesLine);
export default __webpack_public_path__ + "static/media/Document-Favorites-Line.128f7ec7005bb713d0d03474de88d281.svg";
export { ForwardRef as ReactComponent };